import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

import { getCRMTargetYears } from '@services/crmService';

const TargetYear = ({ openModal, placeholder = 'Year', identifier = 'year' }) => {
	const [years, setYears] = useState([]);
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, identifier, identifier);
	const dispatch = useDispatch();

	const setDefaultFilterForTargetTab = async (obj) => {
		if (obj?.id) {
			let data = {
				name: 'year',
				type: 'text',
				key: obj.value,
				value: obj.id,
				identifier: 'year',
				isHideChip: true,
				isClearable: false
			};
			await dispatch(updateTextItemInGlobalFilter(data));
		}
	};

	const fetchList = async () => {
		const data = await getCRMTargetYears();
		let tmpItem = [];
		data.forEach((item) => {
			tmpItem.push({
				id: item,
				value: item
			});
		});
		if (!inputValue) {
			let currentYear = new Date().getFullYear();
			let selectedYear = tmpItem.find((item) => item.id === currentYear);
			await setDefaultFilterForTargetTab(selectedYear || tmpItem[0]);
		}
		setYears(tmpItem);
	};

	useEffect(() => {
		fetchList();
	}, [openModal]);

	const onItemClick = (item) => {
		let data = {
			name: identifier,
			type: 'text',
			key: item.id,
			value: item.value,
			identifier: identifier,
			isHideChip: true,
			isClearable: false
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<CustomDropdown
			type="addItem"
			title={placeholder}
			isShowLabel={false}
			onItemClick={onItemClick}
			items={years}
			selectedItem={inputValue?.value || placeholder}
		/>
	);
};

export default TargetYear;
